<template>
  <div id="nav">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>
<style lang="scss">
#app {
  // background:#fff;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#nav a {
  font-weight: bold;
  color: #234ed0;
  border-bottom: 1px solid #ccc;
}

// #nav a.router-link-exact-active {
//   color: #42b983;
// }
</style>
